import React from 'react';
import RadioSelect from '../../../FormElements/RadioSelect/RadioSelect';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import imgMountSuspendedDirect from '../../../../img/mount-suspended-direct.png';


export const validOptions = ["SI","WI"];

function Uplight(props) {

  

  const {configuration,createItem,setNextEnabled} = props;
  

  function handleChange(event, value) {
    setNextEnabled(true);
    createItem({id:"uplightOutput",value:value});
  }

  return (
    <RadioGroup
      aria-label="Uplight Output"
      name="uplightOutput"
      onChange={handleChange}
      defaultValue={configuration["uplightOutput"] ? configuration["uplightOutput"] : ''}
    >
      <Grid container spacing={3}>
          <Grid item xs={4} sm={3}>
            <RadioSelect disabled={!validOptions.includes(configuration.mountingOptions)} value="L" label="Low" />
          </Grid>
          <Grid item xs={4} sm={3}>
            <RadioSelect disabled={!validOptions.includes(configuration.mountingOptions)} value="M" label="Medium" />
          </Grid>
          <Grid item xs={4} sm={3}>
            <RadioSelect disabled={!validOptions.includes(configuration.mountingOptions)} value="H" label="High"  />
          </Grid>
      </Grid>
    </RadioGroup>
    
  );
}

export default Uplight;